export enum NamesRequestServicesEnum {
  FIND_AVAILABILITY_1 = 'findAvailability1/',
  FIND_AVAILABILITY_2 = 'findAvailability2/',
  FIND_COMPARE = 'findCompare/',
  SEND_INQUIRE_EMAIL = 'sendInquireEmail/',
  ESTATUS_ON_HOLD = 'statusOnHold/',
  ON_HOLD = 'onHold/',
  SEND_INQUIRE_REQUEST_EMAIL = 'sendInquireRequestEmail',
  SEND_CONFIRMATION_EMAIL = 'sendConfirmationMail',
  SEND_INQUIRE_BOOKING_EMAIL = 'sendInquireBookingMail',
  DATE = 'date/',
  }

